<canvas baseChart
                      [data]="pieChartData"
                      [labels]="pieChartLabels"
                      [chartType]="pieChartType"
                      [options]="pieChartOptions"
                      [colors]="pieChartColors"
                      [legend]="pieChartLegend">
</canvas>